{
  "title": "PMPAKET Доставка из Европы",
  "description": "Доставка из Европы",
  "canonicalUrl": "https://app.pmpaket.eu/",
  "themeColor": "#426db7",
  "ogImagePath": "/partners/pmpaket/og-image.png"
}
